import { Box, Button, Container, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import WorkspaceLogo from '~/components/Logo/WorkspaceLogo';
import AppConfig from '~/utils/appconfig';

const LogoutPage: React.FC = () => {
    const handleSignInAgain = () => {
        window.location.href = '/';
    };

    return (
        <Container maxWidth="sm">
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
                textAlign="center"
                gap={4}
            >
                <WorkspaceLogo height={120} />

                <Box>
                    <Typography variant="h5" sx={{ mb: 1 }}>
                        <FormattedMessage
                            id="logoutSuccess"
                            defaultMessage="You have been signed out successfully"
                        />
                    </Typography>

                    <Typography variant="body1" color="text.secondary">
                        <FormattedMessage
                            id="logoutMessage"
                            defaultMessage=" Thank you for using Workspace+"
                        />
                    </Typography>
                </Box>

                <Button
                    variant="contained"
                    color="primary"
                    sx={{ color: 'white' }}
                    onClick={handleSignInAgain}
                >
                    <FormattedMessage
                        id="signInAgain"
                        defaultMessage="Sign in again"
                    />
                </Button>

                <Typography
                    variant="caption"
                    display="block"
                    sx={{ mt: 4, opacity: 0.7 }}
                >
                    <FormattedMessage
                        id="versionInfo"
                        defaultMessage="Version {version}"
                        values={{ version: AppConfig.version }}
                    />
                </Typography>
            </Box>
        </Container>
    );
};

export default LogoutPage;
